"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  _instance: true
};
exports._instance = void 0;

var _BasisTheoryEncryption = require("./BasisTheoryEncryption");

Object.keys(_BasisTheoryEncryption).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _BasisTheoryEncryption[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BasisTheoryEncryption[key];
    }
  });
});

var _constants = require("./common/constants");

Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constants[key];
    }
  });
});

var _utils = require("./utils");

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _utils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _utils[key];
    }
  });
});

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});

/**
 * Default instance used to expose bundle in <script> tags. <br/>
 * Not meant to be used in Node environment.
 */
const _instance = new _BasisTheoryEncryption.BasisTheoryEncryption();

exports._instance = _instance;